// @ts-check
import { forEach, keys } from "lodash";

import { newLineItem, getDailyRateByFlag } from "../../util";

const setSupplyGroupingsWithDemandLineItems = ({
  groupings,
  macroAllocations,
  columnCount,
  groupTypes,
  canRename = false,
  canHide = false,
  isBudgetEnabled = false,
  groupLookup,
  hideHiddenTeams,
}) => {
  forEach(groupings, (grouping) => {
    const macroAllocationsForGrouping = macroAllocations[grouping.groupId];
    const targetGroupIds = keys(macroAllocationsForGrouping);

    forEach(targetGroupIds, (targetGroupId) => {
      const group = groupLookup[targetGroupId];
      if (!group) {
        return;
      }
      const groupType = groupTypes[group.type];
      if (hideHiddenTeams && (group.isHidden || group.isDeleted)) {
        return;
      }
      const lineItem = newLineItem({
        group,
        grouping,
        groupId: targetGroupId,
        columnCount,
        memberCount: group.memberCount,
        canViewInDetails: true,
        canViewInTeamBuilder: true,
        canRename: canRename && groupType.canRename,
        canHide: canHide && !group.isHidden,
        isDemand: true,
        isSkillsMandatory: groupType?.planning?.isSkillsMandatory,
        type: macroAllocationsForGrouping[targetGroupId]?.[0]?.type,
        dailyRate: getDailyRateByFlag(isBudgetEnabled, null, grouping),
      });
      grouping.lineItems.push(lineItem);
    });
    grouping.lineItems.sort((a, b) => a.group.name.localeCompare(b.group.name));

    setSupplyGroupingsWithDemandLineItems({
      groupings: grouping.childGroupings,
      macroAllocations,
      columnCount,
      groupTypes,
      canRename,
      canHide,
      isBudgetEnabled,
      groupLookup,
      hideHiddenTeams,
    });
  });
};

export default setSupplyGroupingsWithDemandLineItems;
